<template>
  <d-card :class="['card-small d-inline-flex', { 'show': show }]" :style="{ 'top': `${up}px`, 'left': `${left}px` }">
    <d-card-body class="px-2 py-0">
      <d-form-row>
        <d-col class="form-group">
          <label>Tamanho</label>
          <d-select v-model="height">
            <option value="">Selecione o tamanho</option>
            <option
              :value="option.value"
              v-for="(option, key) in optionsAvallable"
              :key="key"
            >{{ option.label }}</option>
          </d-select>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <d-button type="button" @click="save()">Salvar</d-button>
        </d-col>
      </d-form-row>
    </d-card-body>
  </d-card>
</template>

<script>
import Events from '_utils/events';
import { cloneDeep } from '_utils';
import {
  CELL,
  SPLIT,
  CELL_SIZE,
  _PUZZLE_UNGROUP_OPTION_,
  _PUZZLE_CLOSE_ALL_MODAL_,
} from '../PuzzleModel';

export default {
  name: 'puzzle-option-ungroup-modal',
  computed: {
    puzzle() {
      const { puzzle } = this.$store.state.puzzle;
      if (puzzle) {
        return puzzle;
      }
      return false;
    },
    optionsAvallable() {
      return SPLIT.filter(item => {
        if (this.cell.type === 'rowspan') {
          if (item.value === 50 || item.value === 0) {
            return false;
          }
        }
        return item;
      });
    },
  },
  data() {
    return {
      up: 0,
      cell: cloneDeep(CELL),
      left: 0,
      show: false,
      height: null,
    };
  },
  methods: {
    save() {
      if (this.cell.type === 'rowspan') {
        this.cell.type = 'row_rowspan';
      } else if (this.cell.type === 'colspan') {
        this.cell.type = 'colspan_row';
      } else if (this.height === 0) {
        this.cell.type = 'colspan_col';
      } else {
        this.cell.type = 'row';
      }
      const positiony = `${this.cell.positiony}_`;
      this.cell.children.push(cloneDeep({
        ...CELL,
        ...{ height: (this.height === 0) ? 100 : this.height, positiony: positiony + 0, positionx: this.cell.positionx },
      }));

      this.cell.children.push(cloneDeep({
        ...CELL,
        ...{ height: 100 - this.height, positiony: positiony + 1, positionx: this.cell.positionx },
      }));
      this.cell.updated = true;
      this.close();
    },
    close() {
      this.show = false;
    },
  },
  destroyed() {
    Events.$off(_PUZZLE_UNGROUP_OPTION_);
    Events.$off(_PUZZLE_CLOSE_ALL_MODAL_);
  },
  mounted() {
    Events.$on(_PUZZLE_UNGROUP_OPTION_, cell => {
      this.cell = cell;
      this.show = cell.active;
      this.up = ((cell.positiony * CELL_SIZE) - 102);
      this.left = ((cell.positionx * CELL_SIZE) + (CELL_SIZE / 2)) - 110;
    });
    Events.$on(_PUZZLE_CLOSE_ALL_MODAL_, () => {
      this.close();
    });
  },
};
</script>

<style lang="scss" scoped>
  .card-small {
    visibility: hidden;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1199;
    transition: all .5 ease-in;
    background: #d7d7d7;
    width: 230px;
    &:before {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -8px;
      border-width: 8px;
      border-style: solid;
      border-color: #d7d7d7 transparent transparent transparent;
    }
    &.show {
      visibility: visible;
      transition: all .5 ease-in;
    }
  }
</style>
